import EntityType from '@/shared/enums/EntityType';

/**
 * Checks if a new activity has been created or re-allocated from a group.
 * @param {Object} - activity
 * @param {Object} - originalActivity
 *
 * @return {Boolean}
 */
export default function includesNewActivity(activity, originalActivity) {
  if (!activity) {
    return false;
  }
  if (!originalActivity) {
    return true;
  }

  return (
    originalActivity?.owner_type === EntityType.GROUP &&
    activity?.owner_type === EntityType.ROLE
  );
}
